import {
    EMPTY_APP,
    FETCH_INDUSTRY_EXPERIENCE_TYPES, FETCH_INDUSTRY_EXPERIENCE_TYPES_SUCCESS, FETCH_INDUSTRY_EXPERIENCE_TYPES_FAILURE,
    FETCH_LOCATIONS, FETCH_LOCATIONS_SUCCESS, FETCH_LOCATIONS_FAILURE,
    FETCH_SKILLS, FETCH_SKILLS_SUCCESS, FETCH_SKILLS_FAILURE,
    FETCH_SPECIALTIES, FETCH_SPECIALTIES_SUCCESS, FETCH_SPECIALTIES_FAILURE
} from './constants';

import clone from 'clone';

const initialState = {
    industryExperienceTypes: [],
    locations: [],
    skills: [],
    specialties: [],
    error: {},
    isFetchingIndustryExperienceTypes: false,
    isFetchingLocations: false,
    isFetchingSkills: false,
    isFetchingSpecialties: false
};

function appReducer(state = clone(initialState), action) {
    switch(action.type) {
        case EMPTY_APP:
            return initialState;
        case FETCH_INDUSTRY_EXPERIENCE_TYPES:
            return Object.assign({}, state, {
                isFetchingIndustryExperienceTypes: true,
                error: {}
            });
        case FETCH_INDUSTRY_EXPERIENCE_TYPES_SUCCESS:
            return Object.assign({}, state, {
                isFetchingIndustryExperienceTypes: false,
                industryExperienceTypes: action.data,
            });
        case FETCH_INDUSTRY_EXPERIENCE_TYPES_FAILURE:
            return Object.assign({}, state, {
                isFetchingIndustryExperienceTypes: false,
                error: action.error
            });
        case FETCH_LOCATIONS:
            return Object.assign({}, state, {
                isFetchingLocations: true,
                error: {}
            });
        case FETCH_LOCATIONS_SUCCESS:
            return Object.assign({}, state, {
                isFetchingLocations: false,
                locations: action.data,
            });
        case FETCH_LOCATIONS_FAILURE:
            return Object.assign({}, state, {
                isFetchingLocations: false,
                error: action.error
            });
        case FETCH_SKILLS:
            return Object.assign({}, state, {
                isFetchingSkills: true,
                error: {}
            });
        case FETCH_SKILLS_SUCCESS:
            return Object.assign({}, state, {
                isFetchingSkills: false,
                skills: action.data,
            });
        case FETCH_SKILLS_FAILURE:
            return Object.assign({}, state, {
                isFetchingSkills: false,
                error: action.error
            });
        case FETCH_SPECIALTIES:
            return Object.assign({}, state, {
                isFetchingSpecialties: true,
                error: {}
            });
        case FETCH_SPECIALTIES_SUCCESS:
            return Object.assign({}, state, {
                isFetchingSpecialties: false,
                specialties: action.data,
            });
        case FETCH_SPECIALTIES_FAILURE:
            return Object.assign({}, state, {
                isFetchingSpecialties: false,
                error: action.error
            });
        default:
            return state;
    }
}

export default appReducer;



// WEBPACK FOOTER //
// ./src/containers/App/store/reducers.js